import NewProject from "@/pages/NewProject";

export default function Onboarding() {
  return <NewProject />;
}
